// Copyright (c) StrangeBee 2024

export const DEFAULT_GROUP = 'Default';
